import { styled } from '@mui/material'
import Toolbar from '@mui/material/Toolbar'
import MuiAppBar, { AppBarProps } from '@mui/material/AppBar'
import { useTopBarHeight } from 'app/menu/components/TopBar/hooks/use-top-bar-height'
import { useFeature } from '@cbgms/base/feature-flags'

export interface CarsysAppBarProps {
  open: boolean
  drawerVisible?: boolean
  drawerWidthClosed: number
  drawerWidthOpen: number
}

interface MUIAppBarProps extends AppBarProps {
  drawerwidthopen: number
  drawerwidthclosed: number
  open?: boolean
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open'
})<MUIAppBarProps>(({ theme, open, drawerwidthopen, drawerwidthclosed }) => ({
  backgroundColor: theme.palette.primaryThemeColor.main,
  color: theme.palette.primaryThemeColor.contrastText,
  zIndex: theme.zIndex.drawer - 1, // Semantic modals are using the same z-index as drawer.
  ...(!open && {
    marginLeft: drawerwidthclosed,
    width: `calc(100% - ${drawerwidthclosed}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  }),
  ...(open && {
    marginLeft: drawerwidthopen,
    width: `calc(100% - ${drawerwidthopen}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}))

export const CarsysAppBar: React.FC<CarsysAppBarProps> = ({ children, open, drawerWidthOpen, drawerWidthClosed, drawerVisible = true }) => {
  const closedOrHidden = drawerVisible ? drawerWidthClosed : 0
  const barHeight = useTopBarHeight()
  const isTopbarUXChangeForTimerEnabled = useFeature('topbar-ux-change-for-timer')

  return (
    <AppBar
      id='topbar-menu'
      sx={{ maxHeight: barHeight, minHeight: barHeight, overflow: 'hidden' }}
      open={drawerVisible && open}
      drawerwidthopen={drawerWidthOpen}
      drawerwidthclosed={closedOrHidden}
      position='fixed'
      data-testid='topbar-menu'
    >
      <Toolbar
        sx={{
          pl: theme => `${theme.spacing(1)} !important`,
          pr: theme => (isTopbarUXChangeForTimerEnabled ? `${theme.spacing(1)} !important` : 'initial')
        }}
      >
        {children}
      </Toolbar>
    </AppBar>
  )
}
